import React, { Component } from "react";
import { Spin } from "antd";
import { Page, Note } from "../../../helbest";
import IconChevronLeft from "../../../assets/images/icons/chevron_left_g.png";
import { API } from "../../../request/api";
import styles from "./Orders.module.css";

import { ReactComponent as EmptyBoxIcon } from "./../../../assets/svg/empty-box.svg";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { LangLink } from "../../components/LangLink/LangLink";

export default class Factors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      factors: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.__get_factors();
  }

  __get_factors() {
    this.setState({ loading: true });
    API.get
      .userBills()
      .then((response) => {
        if (response.success) {
          this.setState({ factors: response.data, loading: false });
        } else {
          Note.error(response.message);
        }
      })
      .catch((error) => {
        Note.error("error in connecting to the server");
        console.log("Error : ", error);
      });
  }

  render() {
    return (
      <Page
        className="page-profile"
        title="Previous services"
        back={true}
        address="/profile/"
        showFooter
        mobileContainer
        headerFix
        customHeader={<HeaderBack title="My Factors" />}
        logo
      >
        {!!this.state.factors &&
          this.state.factors.length === 0 &&
          !this.state.loading && (
            <div className={`${styles.EmptyContainer} ${styles.CenterBase}`}>
              <EmptyBoxIcon className={styles.EmptyBoxIcon} />
              <div className={styles.EmptyText}>No credit found</div>
            </div>
          )}
        {this.state.loading ? (
          <div className="text-center mt-5" style={{ marginTop: 20 }}>
            <Spin className={`${styles.Spin} red`} />
          </div>
        ) : (
          <div
            className={`factors-holder factors-scroll page-factor-factors-container ${styles.FactorHolder}`}
          >
            {this.state?.factors.map((x, i) => (
              <LangLink to={`/p/${x.token}/`} key={i}>
                <div className="factors-item page-factor-factors-item " key={i}>
                  <div className="w-full">
                    <label>Service center name :</label>
                    <span> {x.service_center_name} </span>
                  </div>
                  <div className="w-full">
                    <label>Service Date :</label>
                    <span> {x.date} </span>
                  </div>

                  <hr />

                  <div className="ws-100">
                    show details
                    <img
                      style={{ transform: "rotate(180deg)" }}
                      className="hei-15"
                      src={IconChevronLeft}
                      alt="<"
                    />
                  </div>
                </div>
              </LangLink>
            ))}
          </div>
        )}
      </Page>
    );
  }
}
